import * as React from 'react'

function SvgIconDropArrowN(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="drop-arrow--n" aria-labelledby="t-drop-arrow--n d-drop-arrow--n">
        <title id="t-drop-arrow--n">{'Drop arrow north'}</title>
        <desc id="d-drop-arrow--n">{'Arrow pointing north'}</desc>
        <path d="M7.996 22h16.002c.809 0 1.539-.49 1.851-1.234a2 2 0 00-.436-2.18l-7.999-8a1.998 1.998 0 00-2.825 0l-8.004 8.001A2 2 0 007.996 22z" />
      </g>
    </svg>
  )
}

export default SvgIconDropArrowN
